import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight, FaHome } from 'react-icons/fa';
import { ROUTE_LABELS } from '../../config/themes';

const formatSegment = (segment) => {
  if (ROUTE_LABELS[segment]) return ROUTE_LABELS[segment];
  if (/^[a-f0-9]{24}$/i.test(segment)) return 'Details';
  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const Breadcrumbs = ({ className = '', showHome = true, variant = 'header' }) => {
  const location = useLocation();
  const rawSegments = location.pathname.split('/').filter(Boolean);

  if (rawSegments.length === 0) return null;

  const isHeader = variant === 'header';
  const linkClass = isHeader
    ? 'text-white/70 hover:text-white transition-colors'
    : 'text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors';
  const activeClass = isHeader
    ? 'text-white font-semibold'
    : 'text-gray-900 dark:text-white font-semibold';
  const separatorClass = isHeader
    ? 'w-3 h-3 text-white/50 mx-2'
    : 'w-3 h-3 text-gray-400 dark:text-gray-500 mx-2';

  // Build breadcrumb items, skipping 'admin' for display while maintaining correct path accumulation
  const items = [];
  let currentPath = '';
  rawSegments.forEach((segment) => {
    currentPath += `/${segment}`;
    if (segment !== 'admin') {
      items.push({
        label: formatSegment(segment),
        to: currentPath,
      });
    }
  });

  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={`flex items-center text-sm flex-wrap gap-y-1 ${className}`}>
      {showHome && (
        <>
          <Link to="/dashboard" className={`flex items-center gap-1.5 ${linkClass}`}>
            <FaHome className="w-3.5 h-3.5" />
            <span className="hidden md:inline">Home</span>
          </Link>
          <FaChevronRight className={separatorClass} />
        </>
      )}

      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={item.to}>
            {isLast ? (
              <span className={activeClass}>{item.label}</span>
            ) : (
              <>
                <Link to={item.to} className={linkClass}>
                  {item.label}
                </Link>
                <FaChevronRight className={separatorClass} />
              </>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
